module.exports = __webpack_public_path__ + "assets/969831b7ba5472cf4235c92877121603.mp3";